export default "__VITE_ASSET__10YXgiwy__"